import { render, staticRenderFns } from "./TableUserModeSwitch.vue?vue&type=template&id=ba5f566a&scoped=true&"
import script from "./TableUserModeSwitch.vue?vue&type=script&lang=js&"
export * from "./TableUserModeSwitch.vue?vue&type=script&lang=js&"
import style0 from "./TableUserModeSwitch.vue?vue&type=style&index=0&id=ba5f566a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5f566a",
  null
  
)

export default component.exports